import { NavItemLink } from '../Item';
import type { NavLink, NavLinkNotification } from './links';
import styles from './style.m.less';

type Props = Pick<
    NavLink,
    'title' | 'route' | 'icon' | 'trackingLabel' | 'testId' | 'dataIntercomTarget' | 'specialStyle'
> & {
    isCurrent: boolean;
    isDeactivated?: boolean;
    isCompact: boolean;
    notification?: NavLinkNotification;
};

export function PureNavLink({
    title,
    route,
    icon,
    isCurrent,
    isDeactivated,
    isCompact,
    notification,
    trackingLabel,
    testId,
    dataIntercomTarget,
    specialStyle,
}: Props) {
    return (
        <li className={styles.liReset}>
            <NavItemLink
                label={title}
                icon={icon}
                href={route}
                compact={isCompact}
                current={isCurrent}
                disabled={isDeactivated}
                notification={notification}
                eventTracking={{ category: 'navigation sidebar', action: 'click', label: trackingLabel }}
                testId={testId}
                data-intercom-target={dataIntercomTarget}
                specialStyle={specialStyle}
            />
        </li>
    );
}
